import React, { useState, useEffect, Fragment } from 'react';
import { observer, useObserver } from 'mobx-react-lite';

/* packages */
import useForm from '../../util-hook-useform';
import useSuggest from '../../util-hook-usesuggest';
import validation from '../../util-inputs-validation';
import Input from '../../util-mui-inputs';
import { Inputs, Buttons } from '../../util-atomic';
import { LocalStorage } from '../../lib-atomic-functions';
import { Invalid } from '../../lib-atomic';
/* packages */

/* module */
import StepsLoader from '../loader/steps';
import ProductDefaultInfo from '../../app-module-product-detail/info/default';
/* module */

/* functions */
import { ProductCat1List, ProductCat2List, ProductCat3List, ProductCat4List } from '../../app-module-product-container/functions';
/* functions */

import CONFIG from '../config';


const Index = observer(({ handleNext, handleBack, handleReset, handleCollection, collection }) => {

  const { login } = LocalStorage.getLS();
  const { token } = login;

  const formObjects = CONFIG.application.order.objects_carrier;

  /* states */
  /* product: cards and carriers */
  const { productCat2ListContext, productCat2ListMethod, productCat2ListData } = ProductCat2List({CONFIG, token});
  //const { productCat3ListContext, productCat3ListMethod, productCat3ListData } = ProductCat3List({CONFIG, token});

  useEffect(() => {
    productCat2ListMethod();
  }, []);
  /* states */

  const productSource = productCat2ListData ? productCat2ListData.products : false;

  const productTemplate = (data) => {
    return <ProductDefaultInfo {...data} />
  }

  const productNext = () => {
    handleNext();
  }

  const productBack = () => {
    handleBack();
  }

  const productValidate = () => {
    const { suggestion } = JSON.parse(selectedProduct);
    const total = values.value * values.quantity;
    const newProduct = {...values, ...suggestion, total}
    //handleCollection('status', true); // all good to proceed in checkout quote/order
    handleCollection('products', newProduct);
    values.value = "";
    values.quantity = "";
    values.product = "";
    setSelectedProduct(false);
    setIsSelectedProduct(false);
    setSelectedValue("");
  }

  const productAdd = (data) => {
    if (!data) return handleValue('product', '');
    const { suggestion } = JSON.parse(data);
    return handleValue('product',  String(suggestion.productId));
  }

  const [
    onLoadCompany,
    onResetProduct,
    isSelectedProduct,
    selectedProduct,
    suggestionProduct,
    setSelectedProduct,
    setIsSelectedProduct,
    setSelectedValue,
  ] = useSuggest(productAdd, productTemplate, productSource, 'description');

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    handleValue,
  } = useForm(productValidate, validation, formObjects, false);

  /* form: step 3 */
  const productFormObject = { ...formObjects.product, errors: errors.product, value: values.product, handleChange: handleChange };
  const valueFormObject = { ...formObjects.value, errors: errors.value, value: values.value, handleChange: handleChange };
  const quantityFormObject = { ...formObjects.quantity, errors: errors.quantity, value: values.quantity, handleChange: handleChange };
  /* form: step 3 */

  if (!productSource) return <StepsLoader />

  const isProductCollection = collection.products.length > 0 ? true : false;

  return <form onSubmit={handleSubmit} noValidate>
    <p>Select a product (Trifolds)</p>
    <Input.Suggest {...productFormObject} suggestionProps={suggestionProduct} isSelected={isSelectedProduct} selectedValue={selectedProduct} displayTemplate={productTemplate}>
      <Buttons.PrimarySmall onClick={onResetProduct}>Remove</Buttons.PrimarySmall>
    </Input.Suggest>
    <hr />
    <Input.Text  {...quantityFormObject} />
    <Input.Text {...valueFormObject} />
    <br/>
    <Buttons.Normal>Add product</Buttons.Normal>
    <br/>
    <hr />
    <Buttons.DefaultSmallNon onClick={productBack}>Back</Buttons.DefaultSmallNon>
    { isProductCollection && <Buttons.DefaultSmallNon onClick={productNext}>Next</Buttons.DefaultSmallNon> }
  </form>

});

export default Index;
